import { FC } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes.ts';
import Middleware from '@/router/middleware/index.tsx';
import useCurrentUser from '@/api/useCurrentUser.ts';

const NotLoggedIn: FC = () => {
  const { isLoading, session } = useAuthContext();
  const { data: currentUser, isLoading: isLoadingUser } = useCurrentUser();

  const redirect = session
    ? currentUser?.user_type === 'admin'
      ? Routes.ADMIN_DASHBOARD
      : Routes.DASHBOARD
    : undefined;

  return (
    <Middleware isLoading={isLoading || (session ? isLoadingUser : false)}>
      {!session ? <Outlet /> : <Navigate to={redirect ?? Routes.DASHBOARD} />}
    </Middleware>
  );
};

export default NotLoggedIn;
